import "./MontyMobileDivider.css";

const MontyMobileDivider = () => {
  return (
    <section className="monty-mobile-divider">
      <div className="divrow15">
        <div className="travele-s-i-m-section">
          <img
            className="monty-background-logo4bc5e4d4-icon"
            alt=""
            src="/montybackgroundlogo4bc5e4d4svg.svg"
          />
          <img
            className="jumpingmanb1022dbcpng-icon"
            loading="eager"
            alt=""
            src="/jumpingmanb1022dbcpng@2x.png"
          />
        </div>
        <h2 className="monty-mobile">Trend Mobile</h2>
        <div className="monty-mobile-is-container">
          <span className="monty-mobile-is-container1">
            <p className="monty-mobile-is">
              Trend Mobile is a global fast growing telecommunication
            </p>
            <p className="company-offering-innovative">
              company offering innovative technology and communication
            </p>
            <p className="solutions-we-provide">
              solutions. We provide cutting-edge digital products and services
            </p>
            <p className="for-mobile-network">
              for mobile network operators, enterprises, and service providers
            </p>
            <p className="across-different-industries">
              across different industries.
            </p>
          </span>
        </div>
        <div className="our-revolutionary-omni-container">
          <span className="our-revolutionary-omni-container1">
            <p className="our-revolutionary-omni">
              Our revolutionary Omni channel, messaging, and network
            </p>
            <p className="monetization-platforms-facili">
              monetization platforms, facilitate the international flow of
            </p>
            <p className="communication-globally-allowi">
              communication globally, allowing service providers to offer an
            </p>
            <p className="optimal-customer-experience">
              optimal customer experience while boosting their revenues
            </p>
            <p className="through-a-broad">
              through a broad variety of in-house developed state-of-the-art
            </p>
            <p className="products">products.</p>
          </span>
        </div>
        <div className="with-its-innovative-container">
          <span className="with-its-innovative-container1">
            <p className="with-its-innovative">
              With its innovative solutions, professional customer service and a
            </p>
            <p className="long-lasting-thirst-for">
              long-lasting thirst for improvement, Trend Mobile has grown into
            </p>
            <p className="a-key-regional">
              a key regional player in the telecommunications business,
            </p>
            <p className="gathering-under-its">
              gathering under its portfolio many of the biggest mobile
            </p>
            <p className="operators-and-service">
              operators and service providers around the world.
            </p>
          </span>
        </div>
      </div>
      <div className="travel-e-s-i-m-section-wrapper">
        <div className="travel-e-s-i-m-section">
          <div className="monty-mobile-info-frame">
            <div className="monty-background-parent">
              <div className="monty-background">
                <h2 className="travel-esim">Travel eSIM</h2>
                <div className="one-of-the-container">
                  <p className="one-of-the">
                    One of the most important things that travelers take into
                  </p>
                  <p className="consideration-each-trip">
                    consideration each trip is how to avoid the high roaming
                    rates.
                  </p>
                  <p className="so-they-either">
                    So they either turn mobile data off and depend only on Wi-Fi
                  </p>
                  <p className="which-is-not">
                    which is not always available or buy local SIM card at each
                  </p>
                  <p className="destination-they-arrive">
                    destination they arrive to.
                  </p>
                </div>
              </div>
              <div className="but-now-monty-container">
                <p className="but-now-monty">
                  But now Trend Travel eSIM is a better option they can choose.
                  It
                </p>
                <p className="is-an-international">
                  is an international data eSIM profile, of which the traveler
                  can
                </p>
                <p className="download-its-app">
                  download its app or visit its website to get the profile with
                  no
                </p>
                <p className="need-to-insert">
                  need to insert any physical SIM card and benefit from the most
                </p>
                <p className="competitive-roaming-rates">
                  competitive roaming rates and avoid bill shock. The whole
                </p>
                <p className="process-is-done">
                  process is done via our smart system that looks to the least
                  cost
                </p>
                <p className="network-according-to">
                  network according to the traveler destination and latches
                </p>
                <p className="himher-to">him/her to.</p>
              </div>
            </div>
          </div>
          <img
            className="ukwindow6f071d2bsvg-icon"
            loading="eager"
            alt=""
            src="/ukwindow6f071d2bsvg@2x.png"
          />
        </div>
      </div>
    </section>
  );
};

export default MontyMobileDivider;
